import {AfterContentInit, Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
  ApDynComponentComponent
}                                                                                from '../../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ImportStore
}                                                                                from '../../../stores/import/import.store';
import {filter, map}                                                             from 'rxjs/operators';
import {ApLodash}                                                                from '../../../ap-utils';
import {combineLatest, Observable, of, Subscription}                             from 'rxjs';
import {
  ApDynGridColumnConfigBase
}                                                                                from '../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                                                                from '../../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {ApGridPagerType, IGridPagerData, IWizardChoiceData}                      from '../../../ap-interface';
import {
  ApDynGridStatusColumnConfig
}                                                                                from '../../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  ApDynGridPropertyColumnConfig,
  FilterType
}                                                                                from '../../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridEditColumnConfig
}                                                                                from '../../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  ApUtilService
}                                                                                from '../../../ap-utils/service/ap-util.service';
import {
  ApDynGridPagerConfig
}                                                                                from '../../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import * as moment                                                               from 'moment/moment';
import {
  IImportGridData
}                                                                                from '../../types/ap-logfile-files-overview.types';
import {
  CampaignYearStore
}                                                                                from '../../../stores/login/campaignyear.store';
import {
  GetPermissionPipe
}                                                                                from '../../../ap-permission/pipes/get-permission.pipe';
import {
  ApPermissions
}                                                                                from '../../../../../projects/invoker-transport/src/lib/generated/backend.enums';
import {
  LanguageStore
}                                                                                from '../../../stores/translation/language.store';
import {
  ApTranslationService
}                                                                                from '../../../ap-utils/service/ap-translation.service';
import {
  ApDateService
}                                                                                from '../../../ap-core/services/ap-date-service';
import {
  ApSensorDataService
}                                                                                from '../../../stores/services/ap-sensor-data.service';
import {MapStore}                                                                from '../../../stores/map/map.store';
import {
  ApColumnState
}                                                                                from '../../../ap-interface/enums/ap-column-state.enum';
import {
  IGridStatus
}                                                                                from '../../../ap-interface/interfaces/ap-grid-status.interface';
import IImportDataSet = Data.Import.IImportDataSet;
import ILanguage = Data.Language.ILanguage;

@Component({
  selector: 'ap-logfile-files-overview',
  template: `
    <ap-dyncomponent [columns]="columns"
                     [items]="items$ | async"
                     [loading$]="loading$"
                     [pager]="pager"
                     [groupable]="true"
                     [canSearch]="true"
                     [selectable]="{checkboxOnly: false, mode: 'multiple'}"
    ></ap-dyncomponent>
  `
})
export class ApLogfileFilesOverviewComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true})
  public dynComponent: ApDynComponentComponent;
  public columns: ApDynGridColumnConfigBase[] = [];
  public pager: ApDynGridPagerConfigBase;
  public items$: Observable<any[]> = of([]);
  public loading$: Observable<boolean> = of(false);

  private _subscriptions: Subscription[] = [];
  private _onClick = new EventEmitter<any>();
  private _applyClicked = new EventEmitter<any>();

  constructor(private mapStore: MapStore,
              private importStore: ImportStore,
              private languageStore: LanguageStore,
              private campaignYearStore: CampaignYearStore,
              private dateService: ApDateService,
              private translationService: ApTranslationService,
              private permissionPipe: GetPermissionPipe,
              private sensorService: ApSensorDataService) {
  }

  public ngOnInit(): void {
    this.loading$ = this.importStore.Loading$();
    this.items$ = this._getItems();
    this.importStore.loadImportDataSetTypes();
  }

  public ngAfterContentInit(): void {
    this._subscriptions.push(this._applyClicked.subscribe((d) => this._onApplyClicked(d)));
    this._subscriptions.push(this._onClick.subscribe((e) => this._onShowOnMapClick(e)));
    this._subscriptions.push(
      this.importStore.Listen(s => s.updatedDataSet)
        .pipe(filter(updatedDataSet => !!updatedDataSet))
        .subscribe(updatedDataSet => {
          this.items$ = this.items$.pipe(
            filter(d => !!d),
            map(dataSets => ApLodash.replaceItem(dataSets, this._buildGridDataRecord(updatedDataSet), 'Id'))
          );
        })
    );
    this._subscriptions.push(
      this.campaignYearStore.Listen(s => s.selectedYear).subscribe((cy) => {
        this.importStore.loadImportDataSets(cy);
      })
    );
    this._subscriptions.push(
      combineLatest([
        this.permissionPipe.transform(ApPermissions.SHOW_IMPORTS),
        this.permissionPipe.transform(ApPermissions.EDIT_IMPORTS),
        this.languageStore.SelectedLanguage$
      ]).subscribe(([_, isEditPermissions, selectedLanguage]) => {
        this.columns = this._generateColumns(selectedLanguage);
        this.pager = this._generatePager(isEditPermissions);
      })
    );
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(d => d?.unsubscribe());
  }

  private _getItems(): Observable<IImportGridData[]> {
    return this.importStore.Listen(s => s.data).pipe(
      filter(d => !!d),
      map(d => d.Convert<IImportGridData>((ds: IImportDataSet) => this._buildGridDataRecord(ds)))
    );
  }

  private _generateColumns(selectedLanguage: ILanguage): ApDynGridColumnConfigBase[] {
    return [
      new ApDynGridStatusColumnConfig({
        field: 'Status',
        showHeaderTitle: true,
        class: 'StatusClass',
        description: 'StatusDesc'
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'SourceItem.DataSetName',
        title: 'Global__File',
        filterable: true,
        width: 90,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'UploadDate',
        title: 'Base_Upload__Imported',
        filterable: true,
        format: `${selectedLanguage.DateFormat} ${selectedLanguage.TimeFormat}`,
        width: 90,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'CreatedDate',
        title: 'Global__FieldGeom_Creation_Date',
        filterable: true,
        format: `${selectedLanguage.DateFormat} ${selectedLanguage.TimeFormat}`,
        width: 90,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'SourceItem.DataSetType.DataSetName',
        title: 'Tasks_ViewModel__Type',
        filterable: true,
        width: 90,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'SourceItem.LogCount',
        title: 'Nutrients_Pages__CountSamples',
        filterable: true,
        filterType: FilterType.NUMBER,
        width: 90,
        headerFilterable: true
      }),
      new ApDynGridEditColumnConfig({
        data: [
          {
            text: 'Download_Csv',
            callback: ApUtilService.createEventEmitter(this._downloadCsv.bind(this), this._subscriptions)
          },
          // TODO Log Download fix
          /*{
            text: 'Download_Log',
            callback: ApUtilService.createEventEmitter(this._downloadLog.bind(this), this._subscriptions)
          }*/
        ]
      }),
    ];
  }

  private _generatePager(isEditAvailableForUser: boolean): ApDynGridPagerConfig {
    return new ApDynGridPagerConfig({
      listMassEditing: [
        {
          id: 0,
          name: this.translationService.translate('Download_Csv'),
          type: ApGridPagerType.None,
          values: null
        } as IWizardChoiceData
      ],
      apply: this._applyClicked,
      hasPermission: isEditAvailableForUser
    });
  }

  private _onApplyClicked(data: IGridPagerData): void {
    const rows = this.dynComponent.getSelectedItems();
    switch (data.object.id) {
      case 0:
        this.importStore.downloadCsv(rows.map((row) => row['SourceItem']['MongoFileId']));
        break;
    }
  }

  private _buildGridDataRecord(ds: IImportDataSet): IImportGridData {
    const upload = !!ds.Uploaded ? this.dateService.toFarmDateFromUtcGetJsDate(ds.Uploaded) : undefined;
    const created = !!ds.Uploaded ? this.dateService.toFarmDateFromUtcGetJsDate(ds.Created) : undefined;
    const gridStatus = this.getGridStatus(ds);
    return {
      Id: ds.Id,
      SourceItem: ds,
      Status: gridStatus.state,
      StatusClass: gridStatus.class,
      StatusDesc: gridStatus.description,
      UploadDate: !!upload && upload.getFullYear() > 1910 ? upload : null,
      CreatedDate: !!created && created.getFullYear() > 1910 ? created : null,
    } as IImportGridData;
  }

  private getGridStatus(item: IImportDataSet): IGridStatus {
    if (item.ErrCode != null) {
      return {
        state: ApColumnState.Red,
        class: 'ap-status-red',
        description: item.ErrCode
      };
    }
    if (item.Imported != null && (moment().diff(item.Imported) > 0)) {
      return {
        state: ApColumnState.Green,
        class: 'ap-status-green',
        description: 'Global__Upload_Successfully_Imported'
      };
    }
    return {
      state: ApColumnState.Yellow,
      class: 'ap-status-yellow',
      description: 'Global__Upload_Not_Successfully_Imported'
    };
  }

  private _onShowOnMapClick(dataItem: any): void {
    this.sensorService.loadByDataset(dataItem.Id);
    this.mapStore.Editor.ShowDeleteButton();
  }

  private _downloadCsv(dataItem: any): void {
    this.importStore.downloadCsv(dataItem['SourceItem']['MongoFileId']);
  }

  // TODO Log Download fix
  /*private _downloadLog(dataItem: any): void {
    this.importStore.downloadLog(dataItem['SourceItem']['MongoFileId']);
  }*/
}
